import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Image from 'components/Image';
import Loading from 'components/Loading';

function LoginCopy({ accessCode, isFetching }) {
  if (isFetching) {
    return <Loading />;
  }

  if (accessCode.name) {
    return (
      <div className="media">
        <div className="media__left">
          <span className="card card--sm">
            <Image className="media__object" icon={accessCode.image} alt={accessCode.name} width={60} height={78} />
          </span>
        </div>
        <div className="media__body">
          <h2 className="heading heading--2">Enter Friend!</h2>
          <p dangerouslySetInnerHTML={{ __html: accessCode.initialMessage }} />
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <h2 className="heading heading--2">
        Ten years.<br/> One city.<br/> A thousand choices.
      </h2>
      <p>
        Discover the dark and hilarious Gothic underworld where every action has a consequence.
      </p>
      <p>Fallen London is celebrating ten years as the internet's finest text-based Victorian alternate history roleplaying game! </p>
      <p>Welcome. Delicious friend.</p>
    </Fragment>
  );
}

LoginCopy.propTypes = {
  accessCode: PropTypes.shape({}).isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ accessCodes: { accessCode, isFetching } }) => ({
  accessCode,
  isFetching,
});

export default connect(mapStateToProps)(LoginCopy);